export default "__VITE_ASSET__GPftWJTR__"